import { useRef, useState } from "react";
import Language from "../../lib/Language";
import Icon from "@timeedit/ui-components/components/Icon/Icon";
import PinboardContent from "./PinboardContent";
import { Typography } from "@timeedit/ui-components/components/Typography/Typography";
import TooltippedTopbarButton from "./TooltippedTopbarButton";
import { TOPBAR_BUTTON_ICON_HEIGHT, TOPBAR_HEIGHT } from "../../lib/UIConstants";
import FloatingWindow from "../FloatingWindow";

const TopbarPinboardButton = () => {
    const [open, setOpen] = useState(false);
    const buttonRef = useRef<HTMLDivElement>(null);

    const getWindowPosition = () => {
        if (!buttonRef.current) {
            return {};
        }
        const rect = buttonRef.current.getBoundingClientRect();
        return {
            initialX: Math.round(rect.right - 360),
            initialY: TOPBAR_HEIGHT,
        };
    };

    return (
        <>
            <TooltippedTopbarButton
                ref={buttonRef}
                tooltip={Language.get("nc_pinboard")}
                icon={
                    <Icon
                        id="PinBoard"
                        size={TOPBAR_BUTTON_ICON_HEIGHT}
                        alt={Language.get("nc_pinboard")}
                    />
                }
                onClick={() => {
                    setOpen((prev) => !prev);
                }}
            />
            {open && (
                <FloatingWindow
                    icon={
                        <Icon
                            id="PinBoard"
                            style={{ fontSize: TOPBAR_BUTTON_ICON_HEIGHT }}
                            alt={Language.get("nc_pinboard")}
                        />
                    }
                    title={Language.get("nc_pinboard")}
                    onClose={() => setOpen(false)}
                    {...getWindowPosition()}
                    helpText={
                        <Typography.Text
                            style={{ margin: "4px 0 0", fontSize: 12, color: "white" }}
                        >
                            {Language.get("nc_pinboard_info")}
                            <br />
                            <Typography.Link
                                openInNewTab={true}
                                style={{ color: "white" }}
                                href="https://academy.timeedit.com/guides-tutorials/pinboard"
                            >
                                {Language.get("nc_pinboard_on_te_academy")}
                            </Typography.Link>
                        </Typography.Text>
                    }
                >
                    <PinboardContent height="100%" showTitle={false} />
                </FloatingWindow>
            )}
        </>
    );
};

export default TopbarPinboardButton;
